export type AnalyticsVersion = 'v2' | 'v3'

export type AnalyticsView = 'pools' | 'tokens'

export type TimeFrame = 'D' | 'W' | 'M'

export type AnalyticsDetailsLink = {
  imageURI: string | string[]
  name: string
  address: string
  href: string
}

export enum TransactionType {
  SWAP,
  MINT,
  BURN,
}

// pools

export interface UnifiedPoolToken {
  id: string
  address: string
  symbol: string
  name: string
  decimals: number
  derivedETH?: number
}

export interface UnifiedPoolData {
  id: string
  address: string
  feeTier: number
  token0: UnifiedPoolToken
  token1: UnifiedPoolToken
  tvlUSD: number
  volumeUSD: number
  feesUSD: number
  volumeUSDWeek: number
  feesUSDWeek: number
  volumeUSDChange?: number
  tvlUSDChange?: number
  feesUSDChange?: number
  liquidity?: number
  sqrtPrice?: number
  tick?: number
  token0Price?: number
  token1Price?: number
  tvlToken0?: number
  tvlToken1?: number
  metricsLoaded?: boolean
  metrics24hLoaded?: boolean
  metrics7dLoaded?: boolean
  APR?: number
}

// tokens

export type TokenSnapshot = {
  id: string
  address: string
  symbol: string
  name: string
  derivedETH: number
  volumeUSD: number
  volume: number
  totalValueLocked: number
  totalValueLockedUSD: number
  priceUSD: number
  feesUSD: number
}

export type UnifiedTokenData = {
  id: string
  address: string
  name: string
  symbol: string
  derivedETH: number
  priceUSD: number
  priceUSDChange: number
  priceUSDChangeWeek: number
  volumeUSD: number
  volumeUSDChange: number
  volumeUSDWeek: number
  tvlToken: number
  tvlUSD: number
  fees24hUSD: number
  tvl24hUSDChange: number
  metricsLoaded?: boolean
  metrics24hLoaded?: boolean
  metrics7dLoaded?: boolean
}

// TXs

interface TransactionToken {
  symbol: string
  address: string
  amount: number
}

export interface Transaction {
  type: TransactionType
  hash: string
  timestamp: string
  sender: string
  token0: TransactionToken
  token1: TransactionToken
  amountUSD: number
}

// charts

export interface PoolChartEntry {
  date: number
  volumeUSD: number
  totalValueLockedUSD: number
  feesUSD: number
}

export interface TokenChartEntry {
  date: number
  volumeUSD: number
  totalValueLockedUSD: number
}

export interface ChartDayData {
  date: number
  volumeUSD: number
  tvlUSD: number
  feesUSD: number
  priceUSD?: number
}

export interface GenericChartEntry {
  time: string
  value: number
}

export interface V3ChartData {
  date: number
  volumeUSD: number
  tvlUSD: number
  feesUSD: number
}

export enum VolumeWindow {
  daily,
  weekly,
  monthly,
}

export interface BaseChartData {
  time: string
  value: number
}

export interface PriceChartEntry {
  time: string
  value: number
}

// base

export type TableKind = 'pools' | 'tokens'

export type VersionView = 'v2' | 'v3'

export interface UnifiedPoolToken {
  id: string
  address: string
  symbol: string
  name: string
  decimals: number
  derivedETH?: number
}

export interface UnifiedPoolData {
  id: string
  address: string
  feeTier: number
  token0: UnifiedPoolToken
  token1: UnifiedPoolToken
  tvlUSD: number
  volumeUSD: number
  feesUSD: number
  volumeUSDWeek: number
  feesUSDWeek: number
  volumeUSDChange?: number
  tvlUSDChange?: number
  feesUSDChange?: number
  liquidity?: number
  sqrtPrice?: number
  tick?: number
  token0Price?: number
  token1Price?: number
  tvlToken0?: number
  tvlToken1?: number
  metricsLoaded?: boolean
  metrics24hLoaded?: boolean
  metrics7dLoaded?: boolean
  APR?: number
}
